var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import loginErrorHandler from "./errors/legacy/loginErrorHandler";
import passwordRequestForgotQuery, { passwordRequestForgotKey } from "./queries/passwordRequestForgot";
import passwordSetMutation, { passwordSetKey } from "./mutations/passwordSet";
import passwordSetFromForgotMutation, { passwordSetFromForgotKey } from "./mutations/passwordSetFromForgot";
import passwordSetFromLoginChallengeMutation, { passwordSetFromLoginChallengeKey } from "./mutations/passwordSetFromLoginChallenge";
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Password.prototype.forgot = function (email, tenant, options) {
        if (options === void 0) { options = {}; }
        var variables = { email: email, businessId: tenant.uuid };
        return client
            .query(__assign(__assign({}, options), { fetchPolicy: "no-cache", query: passwordRequestForgotQuery, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data[passwordRequestForgotKey];
        });
    };
    Password.prototype.setForgot = function (userId, confirmation, newPassword, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            userId: userId,
            confirmation: confirmation,
            newPassword: newPassword
        };
        return client
            .mutate(__assign(__assign({}, options), { fetchPolicy: "no-cache", mutation: passwordSetFromForgotMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data[passwordSetFromForgotKey];
        });
    };
    Password.prototype.setLoginChallenge = function (newPassword, challenge, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            challenge: challenge,
            newPassword: newPassword
        };
        return client
            .mutate(__assign(__assign({}, options), { fetchPolicy: "no-cache", mutation: passwordSetFromLoginChallengeMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data[passwordSetFromLoginChallengeKey];
        });
    };
    Password.prototype.change = function (user, oldPassword, newPassword, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            userId: user.uuid,
            newPassword: newPassword,
            oldPassword: oldPassword
        };
        return client
            .mutate(__assign(__assign({}, options), { fetchPolicy: "no-cache", mutation: passwordSetMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data[passwordSetKey];
        });
    };
    return Password;
}(PBService));
var service = new Password({ errorHandlers: [loginErrorHandler] });
export var changePassword = service.change;
export var setLoginChallengePassword = service.setLoginChallenge;
export var forgotPassword = service.forgot;
export var setForgotPassword = service.setForgot;
export default service;
